import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { CACHE_TIME_5_MINUTES, CACHE_TIME_10_MINUTES } from '@/shared/config';
import {
  getVisitHistory,
  type VisitHistoryResponse,
} from '@/widgets/user-profile/visit-history';

const selectLastLoginAt = (data: VisitHistoryResponse): string | null => {
  return data.activities
    .filter(activity => !activity.failed)
    .reduce<string | null>((latest, activity) => {
      if (!latest) return activity.loginDateTime;
      return new Date(activity.loginDateTime).getTime() >
        new Date(latest).getTime()
        ? activity.loginDateTime
        : latest;
    }, null);
};

export const useLastLogin = () => {
  const { session } = useSessionStore();

  const { data, isLoading } = useQuery({
    queryKey: ['profile', 'last-login', session?.userId],
    queryFn: () => getVisitHistory(),
    enabled: !!session?.userId,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    select: selectLastLoginAt,
  });

  return { lastLoginAt: data ?? null, isLoading };
};
